<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to="/Solution">
        <img class="backPic" src="../../static/images/back.png" />
      </router-link>
      <div class="container">
        <img class="solutionDetailTitle1" src="../../static/images/solutionText3.png" />
        <br />
        <img class="solutionDetailTitle2" src="../../static/images/solutionText2.png" />
        <div
          class="solutionDetailText"
        >北斗院提供全域交通的行业解决方案，具备丰富的城市道路交通、轨道交通、公共运输等行业经验。以交通大数据为核心，用数据智能为智慧交通行业赋能，从全新的视角重构和提升智慧交通业务智能化水平。面向交通行业管理部门机构提供“创新产品+解决方案+工程交付+运维维护” 的完整产业链服务。</div>

        <div class="solutionDetailFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">综合交通管理智慧中枢平台</div>
            <div
              class="solutionDetailSecondText"
            >覆盖海港、空港、铁路、公共交通、道路交通、静态交通、道路设施、交通信息服务等全行业。从行政区、热点片区、交通小区、线路、站点、道路、车辆维度进行多维度的监测和分析，建设行业监测、交通大数据分析、可视化展示、中央控制系统，实现了综合交通精细化监测、便捷化操控、科学化决策、高效化指挥。</div>
          </div>
          <div class="solutionDetailItem">
            <img class="solutionDetailPic" src="../../static/images/solutionDetailPic5.png" />
          </div>
        </div>

        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img class="solutionDetailPic" src="../../static/images/solutionDetailPic1.png" />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">公交应急保障</div>
            <div
              class="solutionDetailSecondText"
            >通过节假日及重大活动公交保障监控服务，实时监控节假日及重大活动公交车辆运行及调度情况，有利于提升公交应急调度及监控水平，确保公交车辆动态满足乘客的出行需求，提升公共交通的服务质量。</div>
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">公交场站监管</div>
            <div
              class="solutionDetailSecondText"
            >场站业务数据集成和动态监控，可大大降低公交管理人员的工作强度，提高工作效率，实现公交系统真正的信息化，助力场站管理。</div>
          </div>
          <div class="solutionDetailItem">
            <img class="solutionDetailPic" src="../../static/images/solutionDetailPic2.png" />
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img class="solutionDetailPic" src="../../static/images/solutionDetailPic4.png" />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">道路运行监测</div>
            <div
              class="solutionDetailSecondText"
            >以交通大数据为核心提升和重构现有城市交通管理业务。将大数据、AI技术和实战应用相结合，提升交通路网的疏导能力和决策能力，为建设有序、安全、畅通的出行环境提供信息化支撑。</div>
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">综合枢纽监管</div>
            <div
              class="solutionDetailSecondText"
            >融合多源数据，运用人工智能等技术，为行业监管部门、枢纽管理部门及出行旅客，提供枢纽运行监测、应急指挥、决策分析及信息服务等功能，实现枢纽内“实时监控、快速响应、信息通畅、运力协同、高效换乘、智能服务”，加强各交通方式接驳能力，缩短旅客换乘时间消耗，提高了不同交通方式运行协同效率。</div>
          </div>
          <div class="solutionDetailItem">
            <img class="solutionDetailPic" src="../../static/images/solutionDetailPic3.png" />
          </div>
        </div>
      </div>
      <div class="bottomFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {},
};
</script>
<style scoped>
@import "./solutionDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/SolutionDetail1.vue